// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"39d213ff","91":"de226f76","488":"54fd1ca0","679":"5567d17f","685":"3ced0920","692":"757b1ac9","722":"041cff72","886":"fe5af95d"}[chunkId] + ".chunk.js";
};